export const UKRAINIAN_CITIES = new Map([
  ["Kyiv", ["Kyiv", "Київ", "Киев"]],
  ["Kharkiv", ["Kharkiv", "Харків", "Харьков"]],
  ["Odesa", ["Odesa", "Odessa", "Одеса", "Одесса"]],
  ["Dnipro", ["Dnipro", "Дніпро", "Днепр"]],
  ["Zaporizhzhia", ["Zaporizhzhia", "Zaporizhzhya", "Запоріжжя", "Запорожье"]],
  ["Lviv", ["Lviv", "Львів", "Львов"]],
  ["Kryvyi Rih", ["Kryvyi Rih", "Кривий Ріг", "Кривой Рог"]],
  ["Mykolaiv", ["Mykolaiv", "Миколаїв", "Николаев"]],
  ["Mariupol", ["Mariupol", "Маріуполь", "Мариуполь"]],
  ["Luhansk", ["Luhansk", "Луганськ", "Луганск"]],
  ["Vinnytsia", ["Vinnytsia", "Вінниця", "Винница"]],
  ["Kherson", ["Kherson", "Херсон", "Херсон"]],
  ["Poltava", ["Poltava", "Полтава", "Полтава"]],
  ["Chernihiv", ["Chernihiv", "Чернігів", "Чернигов"]],
  ["Cherkasy", ["Cherkasy", "Черкаси", "Черкассы"]],
  ["Sumy", ["Sumy", "Суми", "Сумы"]],
  ["Zhytomyr", ["Zhytomyr", "Житомир", "Житомир"]],
  ["Khmelnytskyi", ["Khmelnytskyi", "Хмельницький", "Хмельницкий"]],
  ["Chernivtsi", ["Chernivtsi", "Чернівці", "Черновцы"]],
  ["Rivne", ["Rivne", "Рівне", "Ровно"]],
  ["Ivano-Frankivsk", ["Ivano-Frankivsk", "Івано-Франківськ", "Ивано-Франковск"]],
  ["Kropyvnytskyi", ["Kropyvnytskyi", "Кропивницький", "Кропивницкий"]],
  ["Ternopil", ["Ternopil", "Тернопіль", "Тернополь"]],
  ["Lutsk", ["Lutsk", "Луцьк", "Луцк"]],
  ["Uzhhorod", ["Uzhhorod", "Ужгород", "Ужгород"]]
]);

